import React, { useState, useContext } from 'react';

import AppContext from '../../../context/AppContext';
import Checkbox from '../../../shared/Checkbox';
import TextField from '../../../shared/TextField';
import { addItem, deleteItem } from '../../../utils';

const SkillsTab = ({ data, onChange, theme }) => {
  const context = useContext(AppContext);
  const { dispatch } = context;

  return (
    <>
      <div className="my-6 grid grid-cols-6 items-center">
        <div className="col-span-1">
          <Checkbox
            checked={data.skills.enable}
            onChange={v => onChange('data.skills.enable', v)}
            theme={theme}
          />
        </div>
        <div className="col-span-5">
          <TextField
            placeholder="Heading"
            value={data.skills.heading}
            onChange={v => onChange('data.skills.heading', v)}
            theme={theme}
          />
        </div>
      </div>

      <hr className={`my-6 ${theme === 'light' ? 'border-gray-200' : 'border-gray-700'}`} />

      {data.skills.items.map((x, index) => (
        <Item item={x} key={index} index={index} onChange={onChange} dispatch={dispatch} theme={theme} />
      ))}

      <AddItem dispatch={dispatch} theme={theme} />
    </>
  );
};

const AddItem = ({ dispatch, theme }) => {
  const [isOpen, setOpen] = useState(false);
  const [item, setItem] = useState('');

  const add = () => {
    if (item === '') return;

    addItem(dispatch, 'skills', item);

    setItem('');
  };

  return (
    <div className={`my-4 border rounded p-5 ${theme === 'light' ? 'border-gray-200' : 'border-gray-700'}`}>
      <div
        className={`flex justify-between items-center cursor-pointer ${theme === 'light' ? 'text-gray-800' : 'text-gray-200'}`}
        onClick={() => setOpen(!isOpen)}
      >
        <h6 className="text-sm font-medium">Add Skill</h6>
        <i className="material-icons">{isOpen ? 'expand_less' : 'expand_more'}</i>
      </div>

      <div className={`mt-6 ${isOpen ? 'block' : 'hidden'}`}>
        <div className="grid grid-cols-4 col-gap-4">
          <div className="col-span-3">
            <input
              className={`appearance-none block w-full border rounded py-3 px-4 leading-tight focus:outline-none focus:border-gray-500 ${theme === 'light' ? 'bg-gray-200 text-gray-700 border-gray-200 focus:bg-white' : 'bg-gray-700 text-gray-200 border-gray-600 focus:bg-gray-800'}`}
              placeholder="Cooking"
              value={item}
              onChange={e => setItem(e.target.value)}
              type="text"
            />
          </div>

          <button
            type="button"
            onClick={add}
            className="col-span-1 bg-gray-600 hover:bg-gray-700 text-white btn btn-primary"
          >
            <div className="flex justify-center items-center">
              <i className="material-icons font-bold text-lg">add</i>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

const Item = ({ item, index, onChange, dispatch, theme }) => {
  const identifier = `data.skills.items[${index}]`;

  return (
    <div className="my-4 grid grid-cols-6">
      <div className="col-span-5">
        <input
          className={`appearance-none block w-full border rounded py-3 px-4 leading-tight focus:outline-none focus:border-gray-500 ${theme === 'light' ? 'bg-gray-200 text-gray-700 border-gray-200 focus:bg-white' : 'bg-gray-700 text-gray-200 border-gray-600 focus:bg-gray-800'}`}
          placeholder="Cooking"
          value={item}
          onChange={e => onChange(`${identifier}`, e.target.value)}
          type="text"
        />
      </div>

      <button
        type="button"
        onClick={() => deleteItem(dispatch, 'skills', item)}
        className={`col-span-1 text-sm font-medium ${theme === 'light' ? 'text-gray-600 hover:text-red-600' : 'text-gray-400 hover:text-red-400'}`}
      >
        <div className="flex justify-end items-center">
          <i className="material-icons font-bold text-lg pr-4">close</i>
        </div>
      </button>
    </div>
  );
};

export default SkillsTab;
